import React,{Component} from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./LogoCarousel.css"
import {BrandLogos } from "../../data";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1305 },
    items: 6,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1304, min: 501 },
    items: 3,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  }
};

class MultiCarousel extends Component {
    render() {
      return (
<Carousel
centerMode={true}
  additionalTransfrom={0}
  arrows={false}
  autoPlay={true}
  autoPlaySpeed={1000}
  transitionDuration={2000}
  swipeable={true}
  centerMode={false}
  className=""
  containerClass="container-with-dots"
  customTransition="all 1s linear"
  dotListClass=""
  draggable
  focusOnSelect={false}
  infinite
  itemClass=""
  keyBoardControl
  minimumTouchDrag={80}
  renderButtonGroupOutside={false}
  renderDotsOutside={false}
  responsive={responsive}
>
  {
    BrandLogos.map(item =>(
      <>
        <div><img className={item.className} src={item.Brandlogo} alt={item.alt}/></div>
      </>
    ))
  }
 
  
</Carousel>
    );
}
}

export default MultiCarousel
